import { Direction } from '@angular/cdk/bidi';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  Self,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { FloatLabelType, MatFormFieldAppearance } from '@angular/material/form-field';
import { IconType } from '@ng-icons/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';

@Component({
    selector: 'mot-date-picker',
    templateUrl: './mot-date-picker.component.html',
    styleUrls: ['./mot-date-picker.component.scss'],
    standalone: false
})
export class MotDatePickerComponent implements ControlValueAccessor, OnInit {
  @ViewChild('picker') datePicker: MatDatepicker<Date>;

  @Output() onIconClick: EventEmitter<MouseEvent> =
    new EventEmitter<MouseEvent>();
  @Output() onDateChange: EventEmitter<MatDatepickerInputEvent<any, any>> =
    new EventEmitter<MatDatepickerInputEvent<any, any>>();

  @Input() displayErrors: boolean = true;
  @Input() floatLabelType: FloatLabelType = 'auto';
  @Input() label: string;
  @Input() appearance: MatFormFieldAppearance = 'fill';
  @Input() placeholder: string;
  @Input() value: string;
  @Input() type: string;
  @Input() class: string;
  @Input() iconClass: string;
  @Input() icon: IconType;
  @Input() startDate: Date;
  @Input() minDate: Date;
  @Input() maxDate: Date;

  formControl: FormControl;

  /** Unique id for error message (aria-describedby link). */
  errorId = 'mot-date-picker-err-' + Math.random().toString(36).slice(2, 11);

  direction: Direction

  constructor(
    private dateAdapter: DateAdapter<Date>,
    @Optional() @Self() public ngControl: NgControl, private readonly languageService: LanguageService, private readonly resizeService: ResizeService
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    if (this.ngControl) {
      this.formControl = this.ngControl.control as FormControl;
      if (this.value) {
        this.formControl.setValue(this.value);
      }
    }
    this.initializeMultiLanguageTexts();
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction;
      this.dateAdapter.setLocale(language.symbol);
    });
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (!!this.formControl) {
      if (isDisabled) this.formControl.disable();
      else this.formControl.enable();
    }
  }

  getFirstError(): string {
    const errors = this.formControl.errors;

    return errors[Object.keys(errors)[0]];
  }

  openDatePicker(): void {
    if (this.datePicker) {
      this.datePicker.open();
    }
  }
}
